export default __webpack_public_path__ + "static/img12-85c2fc156438634cbeae58dbb0dcd96e.png";